import { ReactNode, useState } from "react";
import Modal from "react-responsive-modal";
import { mdiDelete, mdiFile, mdiFileExcelBox, mdiFilePdfBox, mdiFileWordBox, mdiImage } from "@mdi/js";
import Icon from "@mdi/react";

export function Loading() {
    return <div className="flex-center">
        <div className="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>;
}

export function Remove({ onRemove, children }: { children?: ReactNode, onRemove: () => void }) {
    const [remove, setRemove] = useState(false);
    return (
        <>
            <button className={`remove ${children ? "" : "icon"}`} onClick={() => setRemove(true)}>
                <Icon path={mdiDelete} size={1} /> {children}
            </button>
            <Modal center open={remove} onClose={() => setRemove(false)}>
                <h3>Opravdu smazat tuto položku?</h3>
                <div className="buttons">
                    <button
                        className="danger"
                        onClick={() => {
                            setRemove(false);
                            onRemove();
                        }}
                    >
                        Ano
                    </button>
                    <button onClick={() => setRemove(false)}>Ne</button>
                </div>
            </Modal>
        </>
    );
}

export function FileIcon({ url, size = 1 }: { url: string, size?: number }) {

    let path = mdiFile;
    if (url.endsWith(".pdf")) path = mdiFilePdfBox;
    if (url.endsWith(".jpg") || url.endsWith(".jpeg") || url.endsWith(".png")) path = mdiImage;
    if (url.endsWith(".doc") || url.endsWith(".docx")) path = mdiFileWordBox;

    if (url.endsWith(".xls") || url.endsWith(".xlsx")
        || url.endsWith(".csv") || url.endsWith(".tsv")) path = mdiFileExcelBox;

    return <Icon path={path} size={size} />;
}

export function InputDate({ value, onChange }: { value: string, onChange: (value: string) => void }) {
    return <input type="date" value={value} onChange={(e) => onChange(e.target.value)} />
}
